import { defineMessages } from 'react-intl';

export default defineMessages({
  feeNoteTitle: {
    id: 'side_bar.fee_note',
  },
  warningIppTitle: {
    id: 'transaction.warning_ipp_title',
  },
});
